import { hetch } from "../utils/fetch.hooked";

const DEFAULT_APP_NAME = 'Data Pilot';
const DEFAULT_COMPANY  = 'ООО "Дата Пилот"';

class BrandingService {
    constructor() {
        this.state = { enable: false, appName: '', companyName: '', _fromCache: false, loaded: false };
        try {
            const raw = localStorage.getItem('branding');
            if (raw) {
                const json = JSON.parse(raw);
                this.state.enable = !!json.enable;
                this.state.appName = json.appName ?? '';
                this.state.companyName = json.companyName ?? '';
                this.state._fromCache = true;
            }
        } catch {}

        this._initPromise = null;
    }

    init() {
        if (this._initPromise) return this._initPromise;

        this._initPromise = hetch('/api/public/config')
            .then(res => res.json())
            .then(data => {
                const b = data?.branding;
                if (b) {
                    this.state.enable = !!b.enable;
                    this.state.appName = b.appName ?? '';
                    this.state.companyName = b.companyName ?? '';
                }
                try {
                    localStorage.setItem('branding', JSON.stringify({
                        enable: this.state.enable,
                        appName: this.state.appName,
                        companyName: this.state.companyName,
                    }));
                } catch {}
            })
            .catch(console.error)
            .finally(() => {
                this.state.loaded = true;
                this._initPromise = null;
            });

        return this._initPromise;
    }

    getView() {
        const enable = this.state.enable;

        const appName = String(this.state.appName ?? '').trim();
        const companyName = String(this.state.companyName ?? '').trim();

        const viewAppName = enable ? appName : DEFAULT_APP_NAME
        const viewCompany = enable ? companyName : DEFAULT_COMPANY;
        const showLogo = !enable; // при включенном брендировании скрываем

        return {
            appName: viewAppName,
            companyName: viewCompany,
            showLogo: showLogo,
            loaded: this.state.loaded || this.state._fromCache,
        };
    }

    getAppName()     { return this.getView().appName; }
    getCompanyName() { return this.getView().companyName; }
    shouldShowLogo() { return this.getView().showLogo; }

    isBrandedAppName() {
        const raw = String(this.state.appName ?? '').trim();
        const hasCustom = this.state.enable && raw.length > 0;
        return hasCustom && raw.toLowerCase() !== DEFAULT_APP_NAME.toLowerCase();
    }

    getLoginButtonLabel() {
        if (this.state.enable) {
            const appName = String(this.state.appName ?? '').trim();
            return appName ? 'Войти в ' + appName.toUpperCase() : 'Войти';
        }
        return 'Войти';
    }

    getDocumentTitle() {
        const enable = this.state.enable;
        const name = String(this.state.appName ?? '').trim();
        return enable ? name : DEFAULT_APP_NAME;
    }
}

const brandingService = new BrandingService();
export default brandingService;
